import React, { Fragment, useState, useContext, useEffect } from 'react';
import {
  Paper,
  Grid,
  TextField,
  Button,
  Typography,
  Dialog,
  DialogContent,
} from '@material-ui/core';
import moment from 'moment';
import { useStyles } from '../styles/Styles';
import 'date-fns';
import DocumentUploadContext from '../context/DocumentUpload/documentUploadContext';
import NotificationContext from '../context/Notification/notificationContext';
import OTP from '../components/OTP/OTP';
import Notification from '../components/notification/Notification';
import Spinner from '../components/spinner/Spinner';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import NumberFormat from 'react-number-format';
import DateFnsUtils from '@date-io/date-fns';
import Header from '../components/header/Header';

const Main = () => {
  const classes = useStyles(); //Use Styles from styles/styles.js
  const documentUploadContext = useContext(DocumentUploadContext); //Use documentUploadContext from context/DocumentUploadContext
  const {
    userInfo,
    setUserInfo,
    errors,
    clearErrors,
    loading,
    CheckifSoftLock,
  } = documentUploadContext;
  const notificationContext = useContext(NotificationContext);
  //For ReferenceNumber Textfield
  const [referenceNumber, setReferenceNumber] = useState('');
  //const [onError, setonError] = useState(false);
  const onReferenceNumberChange = (e) => setReferenceNumber(e.target.value);
  //For Birthdate Textfield
  //const [birthDate, setBirthDate] = useState(materialDateInput);
  const [selectedDate, setSelectedDate] = useState(""); //= React.useState(new Date());
  const handleDataChange = (date) => {
    setSelectedDate(date);
  };

  //Submit Form
  const handleSubmitClick = (e) => {
    e.preventDefault();


    if (CheckifSoftLock('FAILEDLOGINTRY', 'LOCKTIME')) {
      setUserInfo(referenceNumber, selectedDate);
    }

  };
  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const clearState = (e) => {
    setReferenceNumber('');
    //setSelectedDate(e);
  };
  //Initializes when page loads or updates
  useEffect(() => {
    if (errors != null) {
      notificationContext.setNotification(errors, 'error');
      clearErrors();
      ////(errors);
    }
    if (userInfo !== null && userInfo !== '') {
      handleClickOpen();
    } // eslint-disable-next-line
    // eslint-disable-line react-hooks/exhaustive-deps
    // eslint-disable-next-line
  }, [userInfo, errors]); // eslint-disable-next-line
  return (
    <div>
      <Header page={4} />
      <div className={classes.banner}>
        <form onSubmit={handleSubmitClick}>
          <Fragment>
            <Typography className={classes.paragraph}>
              You may now open a PSBank account on your mobile phone. Just
              download the PSBank Mobile App in Apple Store and Google Play Store.
              Start to save money, transfer funds, pay bills and online purchases
              in just a few clicks.
            </Typography>

            <Typography
              className={classes.paragraph}
              style={{ paddingTop: '3%' }}
            >
              For customers completing their online account application, please
              enter your account opening details below to proceed with the
              submission of additional requirements requested by a PSBank
              representative.
            </Typography>
            <Button
              color='primary'
              className={classes.clrButton}
              onClick={clearState}
            >
              Clear
            </Button>

            <Paper elevation={0} className={classes.paper}>
              <Notification />
              {loading ? (
                <Spinner />
              ) : (
                  <Fragment>
                    <Grid container spacing={3}>
                      <Grid item md={6} xs={12}>
                        <p classes={classes.txtFldLbl}>Reference Number</p>

                        <TextField
                          className={classes.txtField}
                          name='referenceNumber'
                          autoComplete='off'
                          id='referenceNumber'
                          variant='outlined'
                          type='text'
                          value={referenceNumber}
                          onChange={onReferenceNumberChange}
                          InputLabelProps={{ required: true }}
                          InputProps={{
                            inputComponent: NumberFormat,
                          }}
                        ></TextField>
                      </Grid>

                      <Grid item md={6} xs={12}>
                        <p classes={classes.txtFldLbl}>Birth Date</p>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                          <KeyboardDatePicker
                            className={classes.txtField}
                            required
                            disableToolbar
                            variant='dialog'
                            inputVariant='outlined'
                            format='MM/dd/yyyy'
                            disableFuture
                            //invalidDateMessage='Please provide valid Birth Date.'
                            //invalidLabel='Please provide valid Birth Date.'
                            maxDateMessage='Please provide valid Birth Date.'
                            minDateMessage='Please provide valid Birth Date.'
                            //emptyLabel='Please provide valid Birth Date.'
                            minDate='1000-01-01'
                            id='selectedDate'
                            value={selectedDate ? moment(selectedDate) : null}
                            onChange={handleDataChange}
                            placeholder='MM/dd/yyyy'
                            // onError={() => setonError(true)}
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                              className: classes.dateadorn,
                            }}
                            inputProps={{
                              className: classes.datepicker,
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={8}
                      direction='row'
                      justify='center'
                      alignItems='center'
                    >
                      {referenceNumber === '' || selectedDate === null ? ( //ADD OR SOFTLOCK
                        <Grid item xs={8} sm={5} md={3} lg={3} xl={3}>
                          <Button
                            style={{
                              textAlign: 'right',
                              textTransform: 'capitalize',
                              fontSize: '12px',
                              width: '100%',
                              marginTop: '1rem',
                            }}
                            variant='contained'
                            color='primary'
                            type='submit'
                            disabled
                          >
                            Submit
                        </Button>
                        </Grid>
                      ) : (
                          <Grid item xs={8} sm={5} md={3} lg={3} xl={3}>
                            <Button
                              style={{ textAlign: 'right' }}
                              className={classes.button}
                              variant='contained'
                              color='primary'
                              type='submit'
                            >
                              Submit
                        </Button>
                          </Grid>
                        )}
                    </Grid>
                  </Fragment>
                )}
            </Paper>

            <Dialog aria-labelledby='customized-dialog-title' open={open}>
              <DialogContent dividers>
                <OTP handleClose={handleClose} />
              </DialogContent>
            </Dialog>
          </Fragment>
        </form>
    </div>
    </div>
  );
};

export default Main;
